import React from 'react'
import { DialogTitle, Dialog, DialogContent } from '@material-ui/core'

const Spiner = ({ opt }) => {
  return (
    <Dialog 
      open={Boolean(opt)} 
      aria-labelledby="alert-dialog-title" 
      aria-describedby="alert-dialog-description"
      style={{ position: "fixed", zIndex: 1400, inset: "0px" }}>
      
      {/* Título antes del contenido para mejor semántica */}
      <DialogTitle id="alert-dialog-title" className="text-center">
        <b>Cargando...</b>
      </DialogTitle>

      <DialogContent>
        {/* Se reemplaza DialogContentText por un div para evitar el error */}
        <div id="alert-dialog-description" className="text-center mt-4 mb-4">
          <div className="loader mt-2"></div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default Spiner
